import { clientPost } from "@/service/client-api/client-api";

const timeout = 12000;

let isViewOverflown: Record<string, number> = {};
let actualView = "";

export function coopIn() {
  // Podgląd banera (?bannerPreview, screeny kampanii) nie nabija wyświetleń ani cappingu.
  if (new URLSearchParams(window.location.search).has("bannerPreview")) {
    return;
  }

  const options = {
    threshold: 0,
  };

  const handleIntersect = (entries, observer) => {
    entries.forEach(
      async (entry: {
        target: {
          dataset: { view: string };
          parentElement: { dataset: { logViewData: string; uuid: string } };
        };
        isIntersecting: boolean;
      }) => {
        const viewURL = entry.target.dataset.view;

        if (actualView !== window.location.pathname) {
          isViewOverflown = {};
          actualView = window.location.pathname;
        }

        if (
          entry.isIntersecting &&
          document.hasFocus() &&
          (!isViewOverflown[viewURL] || isViewOverflown[viewURL] < 20)
        ) {
          isViewOverflown[viewURL] = !isViewOverflown[viewURL]
            ? 1
            : isViewOverflown[viewURL] + 1;

          const { logViewData, uuid } = entry.target.parentElement.dataset;

          const logEventData = JSON.parse(logViewData);

          clientPost(
            "banner.view",
            {
              uuid,
            },
            logEventData,
          );
        }
      },
    );
  };

  const observer = new IntersectionObserver(handleIntersect, options);

  for (const target of Array.from(
    document.querySelectorAll(
      ".banner-slide--active .coop:not(.coop--observed)",
    ),
  )) {
    target.classList.add("coop--observed");
    observer.observe(target);
  }
}

function changeSlide({
  slider,
  campaigns,
  activeCampaign,
}: {
  slider: HTMLElement;
  campaigns: { count: number; active: number }[];
  activeCampaign: number;
}) {
  if (!document.hasFocus()) {
    return;
  }

  // First remove the active class from all slides
  Array.from(slider.querySelectorAll(".banner-slide")).forEach((slide) => {
    slide.classList.remove("banner-slide--active");
  });

  // Then add the active class only to the specific slide that matches both indices
  const targetSlide = slider.querySelector(
    `.banner-slide[data-campaign-index="${activeCampaign}"][data-banner-index="${campaigns[activeCampaign].active}"]`,
  );

  if (targetSlide) {
    targetSlide.classList.add("banner-slide--active");
  }

  coopIn();
}

function handleView(config: {
  campaigns: { count: number; active: number }[];
  activeCampaign: number;
  slider: HTMLElement;
}) {
  const { activeCampaign } = config;

  if (!config.campaigns[activeCampaign]) {
    return;
  }

  config.campaigns[activeCampaign].active += 1;
  if (
    config.campaigns[activeCampaign].active >
    config.campaigns[activeCampaign].count - 1
  ) {
    config.campaigns[activeCampaign].active = 0;
  }

  config.activeCampaign += 1;

  if (config.activeCampaign > config.campaigns.length - 1) {
    config.activeCampaign = 0;
  }

  changeSlide(config);
}

export function handleBannerSlides() {
  const sliders = Array.from(
    document.querySelectorAll(".banner:not(.banner--observed)"),
  );

  sliders.forEach((slider) => {
    slider.classList.add("banner--observed");
    const campaigns: { count: number; active: number; cid: number }[] = [];

    Array.from(slider.querySelectorAll<HTMLElement>(".banner-slide")).forEach(
      (slide) => {
        const { campaignIndex, cid } = slide.dataset as {
          campaignIndex: string;
          cid: string;
        };
        if (campaigns[Number(campaignIndex)]) {
          campaigns[Number(campaignIndex)].count += 1;
        } else {
          campaigns.push({
            count: 1,
            active: 0,
            cid: Number(cid),
          });
        }
      },
    );

    const config: {
      campaigns: { count: number; active: number }[];
      activeCampaign: number;
      slider: HTMLElement;
    } = {
      campaigns,
      activeCampaign: 0,
      slider,
    };

    const intervalFunction = () => {
      handleView(config);
    };

    let interval = setInterval(intervalFunction, timeout);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio === 0) {
          handleView(config);
          clearInterval(interval);
        } else {
          clearInterval(interval);
          interval = setInterval(intervalFunction, timeout);
        }
      });
    });

    observer.observe(slider);
  });
}
